import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AttachmentsViewComponent } from '../attachments-view/attachments-view.component';




@NgModule({
  declarations: [AttachmentsViewComponent],
  imports: [
    CommonModule,
  ],
  exports: [
    AttachmentsViewComponent
  ],
  bootstrap: [AttachmentsViewComponent],

})
export class AttachmentsViewModuleModule { }
